import { render, staticRenderFns } from "./CollateTitleBar.vue?vue&type=template&id=4af0fb53&"
import script from "./CollateTitleBar.vue?vue&type=script&lang=js&"
export * from "./CollateTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports